var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18898",
    d: "M0.65 0.65H5.31452L8.35 3.62596V11.35H0.65V0.65Z",
    stroke: "#637381",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M5.02446 3.52556L5.02456 1.75147L6.7982 3.52554L5.02446 3.52556Z",
    fill: "#637381",
    stroke: "#637381"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconSmall);
export default __webpack_public_path__ + "static/media/file-icon-small.129a5b37be767d514ca648c3a59064b0.svg";
export { ForwardRef as ReactComponent };